import {
  GAME_ID,
  INIT_GOBLINS_LINE,
  MOVE_GOBLINS_LINE,
  GOBLIN_IDLE,
  GOBLIN_WRONGORDER,
  GOBLIN_YUM,
  GOBLIN_ANIMATION_KEYS,
} from '../data/goblinGourmetConstants';

const initialState = {
  goblinsLine: [],
  currentGoblinId: null,
  currentAnimationKey: null,
};

const goblinGourmetGoblinReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case INIT_GOBLINS_LINE: {
      const { goblinsLine } = action.payload;

      return {
        ...initialState,
        goblinsLine,
        currentGoblinId: goblinsLine[0],
        currentAnimationKey: GOBLIN_ANIMATION_KEYS.IDLE,
      };
    }
    case MOVE_GOBLINS_LINE: {
      // pick last element and put into end of line
      const goblinsLine = [...state.goblinsLine.slice(1), state.goblinsLine[0]];

      return {
        ...state,
        currentGoblinId: goblinsLine[0],
        goblinsLine,
      };
    }
    case GOBLIN_IDLE: {
      return {
        ...state,
        currentAnimationKey: GOBLIN_ANIMATION_KEYS.IDLE,
      };
    }
    case GOBLIN_WRONGORDER: {
      return {
        ...state,
        currentAnimationKey: GOBLIN_ANIMATION_KEYS.WRONGORDER,
      };
    }
    case GOBLIN_YUM: {
      return {
        ...state,
        currentAnimationKey: GOBLIN_ANIMATION_KEYS.YUM,
      };
    }
    default:
      return state;
  }
};

export default goblinGourmetGoblinReducer;
